export default function uuid() {
  return [...Array(36).keys()]
    .map((i) => {
      if (i === 8 || i === 13 || i === 18 || i === 23) {
        return '-';
      }

      if (i === 14) {
        return '4';
      }

      if (i === 19) {
        return (Math.floor(Math.random() * 4) + 8).toString(16);
      }

      return Math.floor(Math.random() * 15).toString(16);
    })
    .join('');
}
